import { TermsOfUseForManufacturerServicesSubPage } from '../TermsOfUseForManufacturerServicesSubPage';

export const ServiceAbsPlannerPage = () => (
  <TermsOfUseForManufacturerServicesSubPage page="portal.termsOfUse.manufacturerServices.absPlanner" />
);
